import React from "react";


const NoPage = () => {
    return(
        <div className="container">
            <h2>Такой страницы нет</h2>
        </div>
    )
}

export default NoPage;